<div
	class="wrapper"
	[ngClass]="{ 'info-card': infoCard }"
	#wrapper
	[style.padding]="group.name ? '6px 0' : 0"
	(mouseenter)="hovered = true"
	(mouseleave)="hovered = false; pressed = false"
	(mousedown)="pressed = true"
	(click)="pressed = false; clickEvent.emit(group)"
	[@pressState]="pressed ? 'down' : 'up'"
	[style.background-color]="backgroundColor">
	<div class="group-name tw-flex tw-items-center">
		<span *ngIf="group.name" class="tw-text-base">{{ group.name }}</span>
		<span *ngIf="numOverrides && !studentProfileView" class="tw-text-gray-400 tw-font-normal tw-text-sm" [ngClass]="{ 'tw-ml-1.5': group.name }"
			>{{ numOverrides }} Overrides</span
		>
		<div class="chip tw-ml-auto" [ngClass]="{ 'tw-mr-11': studentProfileView }" *ngIf="!group.enabled">Disabled</div>
	</div>
	<p *ngIf="activityEPFF" class="tw-bg-red-100 tw-text-red-500 tw-w-max tw-my-1 tw-ml-[15px] tw-px-1 tw-py-0.5 tw-rounded tw-text-xs">{{ group.prevention_type == 'passes_and_activities' ? 'Hall Pass & Activity Prevention' : 'Hall Pass Prevention' }}</p>
	<div class="students">
		<div class="student" *ngFor="let student of group.users">
			<div class="student-picture">
				<div
					*ngIf="student.profile_picture; else d"
					class="tw-w-6 tw-h-6"
					[ngStyle]="{ background: 'url(' + student.profile_picture + ') no-repeat left center/cover' }"></div>
				<ng-template #d>
					<img class="tw-w-6 tw-h-6" [src]="'./assets/Avatar Default.svg' | resolveAsset" alt="" />
				</ng-template>
			</div>
			<div class="name" notranslate>{{ student.display_name }}</div>
		</div>
	</div>
	<ng-template #name>
		<div class="group-name">
			{{ group.name }}
		</div>
	</ng-template>

	<div class="octagon" [style.top]="group.name ? '15px' : '10px'">
		<app-octagon *ngIf="!hovered; else go" [size]="28" [backgroundColor]="'transparent'" [borderColor]="'#E32C66'" [borderWidth]="5">
			<div
				class="value tw-text-red-500"
				[ngClass]="{
					'tw-text-xs': numPreventedEncounters >= 100 && numPreventedEncounters < 1000,
					'tw-text-xxs': numPreventedEncounters >= 1000
				}">
				{{ numPreventedEncounters }}
			</div>
		</app-octagon>
		<ng-template #go>
			<app-icon-button [srcString]="'Chevron Right'" [size]="15" (clickEvent)="clickEvent.emit($event)"></app-icon-button>
		</ng-template>
	</div>
</div>
